import { render } from "./open-vip.vue?vue&type=template&id=40dbc57e&scoped=true"
import script from "./open-vip.vue?vue&type=script&lang=ts"
export * from "./open-vip.vue?vue&type=script&lang=ts"

import "./open-vip.vue?vue&type=style&index=0&id=40dbc57e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-40dbc57e"

export default script